import cn from 'bem-cn';

import { Icon, Stack } from '../../../../UI';

import { ChallengeCriteriaProps } from './ChallengeCriteria.types';
import './ChallengeCriteria.scss';

const b = cn('challenge-criteria');

export const ChallengeCriteria = (props: ChallengeCriteriaProps) => {
    const { percent, text, icon } = props;

    return (
        <Stack className={b()} justifyContent="space-between">
            <Stack direction="row" justifyContent="space-between" alignItems="center">
                <h3>{percent}%</h3>
                <Icon name={icon as never} fillColor="var(--accent-color)" />
            </Stack>
            <p>{text}</p>
        </Stack>
    );
};
